// src/hooks/useInviteRequest.ts
import { useState } from 'react';
import { API_BASE_URL } from '../config';

type InviteRequest = {
  name: string;
  email: string;
};

type InviteRequestResult = {
  success: boolean;
  message: string;
  waitlisted?: boolean;
};

export const useInviteRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const requestInvite = async (data: InviteRequest): Promise<InviteRequestResult> => {
    setIsLoading(true);
    setError('');

    try {
      console.log('Making API request to:', `${API_BASE_URL}/api/invites/request`);
      console.log('With data:', data);
      
      // For development: temporary mock success if API is unavailable
      // Remove this block when your API is working properly
      if (!API_BASE_URL) {
        console.log('Using mock implementation since API_BASE_URL is empty');
        return new Promise(resolve => {
          setTimeout(() => {
            setIsLoading(false);
            resolve({
              success: true,
              message: `Invite request for ${data.email} processed successfully!`,
              waitlisted: false
            });
          }, 1000);
        });
      }

      const response = await fetch(`${API_BASE_URL}/api/invites/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      console.log('API response:', result);

      if (!response.ok) {
        throw new Error(result.message || 'Failed to request invite code');
      }

      return result;
    } catch (err) {
      console.error('Error in requestInvite:', err);
      const errorMessage = err instanceof Error ? err.message : 'An unexpected error occurred';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    requestInvite,
    isLoading,
    error,
  };
};